import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const CarIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M15.92 1.12719C15.72 0.537188 15.16 0.117188 14.5 0.117188H3.5C2.84 0.117188 2.29 0.537188 2.08 1.12719L0 7.11719V15.1172C0 15.6672 0.45 16.1172 1 16.1172H2C2.55 16.1172 3 15.6672 3 15.1172V14.1172H15V15.1172C15 15.6672 15.45 16.1172 16 16.1172H17C17.55 16.1172 18 15.6672 18 15.1172V7.11719L15.92 1.12719ZM4.5 11.1172C3.67 11.1172 3 10.4472 3 9.61719C3 8.78719 3.67 8.11719 4.5 8.11719C5.33 8.11719 6 8.78719 6 9.61719C6 10.4472 5.33 11.1172 4.5 11.1172ZM13.5 11.1172C12.67 11.1172 12 10.4472 12 9.61719C12 8.78719 12.67 8.11719 13.5 8.11719C14.33 8.11719 15 8.78719 15 9.61719C15 10.4472 14.33 11.1172 13.5 11.1172ZM2.81 5.11719L3.85 2.11719H14.14L15.18 5.11719H2.81Z",
    fill: color
  }));
};
export default CarIcon;